<template>
    <div>
        <span>{{ item.title }}</span>
        <template v-if="!isRemoving">
            <i
                id="remove-category-btn"
                @click.stop="confirmRemoveCategory(item)"
                class="fal fa-times ml-3"
                title="Remover categoria permanentemente do site"
            />
        </template>

        <template v-else>
            <b-spinner class="list-pages--spinner" label="Removendo categoria"></b-spinner>
        </template>
    </div>
</template>

<script>
export default {
    name: "Category",
    data() {
        return {
            isRemoving: false,
        }
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        isModalEventCancelled: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    methods: {
        confirmRemoveCategory() {
            this.$emit('confirmRemoveCategory', this.item);
            setTimeout(() => {
                this.isRemoving = true;
            }, 1000);
        }
    },
    watch: {
        isModalEventCancelled(val, oldVal) {
            if (val == true) { this.isRemoving = false; }
        }
    }
}
</script>

<style>
.list-pages--spinner {
    width: 16px;
    height: 16px;
    vertical-align: unset;
    color: var(--main-color);
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/Category.vue